import {forwardRef} from 'react'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Slide from '@mui/material/Slide'
import PropTypes from 'prop-types'
import {StyledDialog, StyledDialogTitle} from './CustomDialogStyle'

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} mountOnEnter unmountOnExit timeout={{enter: 400, exit: 200}} />
})

const CustomDialog = ({size, isOpened, title, content, footer, handleClose, underlineTitle = true}) => {
  const handleDialogClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      handleClose(event)
    }
  }

  return (
    <StyledDialog
      open={isOpened}
      fullWidth={true}
      maxWidth={size}
      TransitionComponent={Transition}
      onClose={handleDialogClose}
      scroll='paper'
      aria-describedby='dialog-description'
    >
      <StyledDialogTitle underlineTitle={underlineTitle}>{title}</StyledDialogTitle>
      <DialogContent id='dialog-description'>{content}</DialogContent>
      <DialogActions>{footer}</DialogActions>
    </StyledDialog>
  )
}

CustomDialog.propTypes = {
  isOpened: PropTypes.bool,
  title: PropTypes.node,
  content: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.string,
  underlineTitle: PropTypes.bool,
  handleClose: PropTypes.func
}

export default CustomDialog
